import { put, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import { fetchOverview, fetchQueueItem } from '@/features/admin/store/admin.slice';
import * as claimsApi from '../api/claims.api';
import { decideClaim, fetchClaim, requestClaimInfo } from './claims.slice';

const apiSaga = createPanelApiSaga();

/**
 * Sahiplenme sagaları — Blok 8-2'den sonra YALNIZCA moderasyon yüzeyi.
 * Önbellek notu (INVALIDATION_MAP): `claims/decide` talep listesini, etkinlik
 * ayrıntısını ve admin kuyruğu/KPI'larını; `claims/requestInfo` yalnız kuyruğu
 * bayatlatır. Tazeleme burada AÇIKÇA yapılır.
 */
export function* claimsSaga() {
  yield takeLatest(fetchClaim.request.type, apiSaga(fetchClaim, claimsApi.fetchClaim));

  yield takeLatest(
    decideClaim.request.type,
    apiSaga(
      decideClaim,
      async (arg) => ({
        claim: await claimsApi.decideClaim(arg.claimId, arg.input),
        queueItemId: arg.queueItemId,
      }),
      {
        onSuccess: function* (result) {
          if (result.queueItemId) {
            yield put(fetchQueueItem.request(result.queueItemId));
            yield put(fetchOverview.request());
          }
        },
      },
    ),
  );

  yield takeLatest(
    requestClaimInfo.request.type,
    apiSaga(
      requestClaimInfo,
      async (arg) => {
        await claimsApi.requestClaimInfo(arg.claimId, arg.input);
        return { queueItemId: arg.queueItemId };
      },
      {
        onSuccess: function* (result) {
          if (result.queueItemId) {
            yield put(fetchQueueItem.request(result.queueItemId));
          }
        },
      },
    ),
  );
}
